{
  "title": "Enhance Ability",
  "source": "Player's Handbook",
  "levelAndSchool": "2nd-level transmutation",
  "level": 2,
  "castingTime": "1 action",
  "range": "Touch",
  "components": "V, S, M (fur or a feather from a beast)",
  "duration": "Concentration, up to 1 hour",
  "description": [
    "You touch a creature and bestow upon it a magical enhancement. Choose one of the following effects; the target gains the effect until the spell ends.",
    "Bear’s Endurance. The target has advantage on Constitution checks. It also gains 2d6 temporary hit points, which are lost when the spell ends.",
    "Bull’s Strength. The target has advantage on Strength checks, and their carrying capacity doubles.",
    "Cat’s Grace. The target has advantage on Dexterity checks. It also doesn’t take damage from falling 20 feet or less if it isn’t incapacitated.",
    "Eagle’s Splendor. The target has advantage on Charisma checks.",
    "Fox’s Cunning. The target has advantage on Intelligence checks.",
    "Owl’s Wisdom. The target has advantage on Wisdom checks.",
    "At Higher Levels. When you cast this spell using a spell slot of 3rd level or higher, you can target one additional creature for each slot level above 2nd."
  ],
  "spellLists": ["artificer", "bard", "cleric", "druid", "ranger", "sorcerer", "wizard"]
}
